jQuery(document).ready(function(){

   
   // Product Slider 
    const single_product = jQuery('#bz-product-gallery.owl-carousel');
    single_product.owlCarousel({
        loop:false,
        margin:10,
        nav:false,
        dots:false,
        margin:35,
        URLhashListener:true,
        startPosition: 'URLHash',
        responsive:{
            0:{
                items:2,
                nav:true,
                navText:['<i class="fa-solid fa-chevron-left"></i>','<i class="fa-solid fa-chevron-right"></i>']
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    })
    
    // Product Slider Main
    const single_product_main = jQuery('#bz-product-gallery-top.owl-carousel');
    single_product_main.owlCarousel({
        loop:false,
        margin:10,
        nav:false,
        dots:false,
        margin:35,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    })
});